import { render, staticRenderFns } from "./EmbedPage.vue?vue&type=template&id=29b7184a&"
import script from "./EmbedPage.vue?vue&type=script&lang=js&"
export * from "./EmbedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports